import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import OutlineNode from './OutlineNode';
import { buildView } from './viewBuilders';
import './outline.css';




const Breadcrumb = ({ path, onNavigate }) => {
  return (
    <div className="breadcrumb">
      <span 
        className="breadcrumb-item root"
        onClick={() => onNavigate(null)}
        style={{cursor: 'pointer', color: "#0066cc", textDecoration: 'underline'}}
      >
        root
      </span>
      {path.map((block, index) => (
        <React.Fragment key={block.id}>
          <span className="breadcrumb-separator"> &gt; </span>
          <span 
            className="breadcrumb-item" 
            onClick={() => onNavigate(block.id)}
            style={{cursor: 'pointer', color: "#0066cc", textDecoration: 'underline'}}
          >
            {block.content || block['page-name'] || 'Unnamed Block'}
          </span>
        </React.Fragment>
      ))}
    </div>
  );
};



const OutlineDisplay = ({ data, processedData, viewName = 'default'  }) => {
  const [rootBlocks, setRootBlocks] = useState([]);
  const { blockId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (processedData && blockId && !processedData.idToBlockMap.has(blockId)) {
      // If the blockId in the URL is invalid, navigate to the root
      navigate('/', { replace: true });
    }
  }, [processedData, blockId, navigate]);

  useEffect(() => {
    const { idToBlockMap } = processedData;
    const originalRootBlocks = data.blocks.filter(block => block['page-name']);

    const syntheticRootBlocks = buildView(viewName, originalRootBlocks);

    setRootBlocks(syntheticRootBlocks);

    // Add synthetic blocks to idToBlockMap
    syntheticRootBlocks.forEach(block => {
      idToBlockMap.set(block.id, block);
    });
  }, [data, processedData, viewName]);

  const handleZoom = (blockId) => {
    navigate(blockId ? `/block/${blockId}` : '/');
  };

  const getBreadcrumbPath = (blockId) => {
    const path = [];
    let currentId = blockId;
    const { idToBlockMap } = processedData;

    while (currentId) {
      const block = idToBlockMap.get(currentId);
      if (block) {
        if (currentId !== blockId){
          path.unshift(block);
        }
        currentId = block.parentId;
      } else {
        break;
      }
    }

    return path;
  };

  if (!processedData) {
    return <div>Loading...</div>;
  }

  const { idToBlockMap, idToReferencesMap } = processedData;
  
  const currentBlock = blockId ? idToBlockMap.get(blockId) : null;
  const breadcrumbPath = currentBlock ? getBreadcrumbPath(blockId) : [];

  const displayBlocks = currentBlock ? [currentBlock] : rootBlocks;

  return (
    <div className="outline-display">
      <Breadcrumb path={breadcrumbPath} onNavigate={handleZoom} />
      <ul>
        {displayBlocks.map((block) => (
          <OutlineNode 
            key={block.id} 
            block={block} 
            idToBlockMap={idToBlockMap}
            idToReferencesMap={idToReferencesMap}
            onZoom={handleZoom} 
          />
        ))}
      </ul>
    </div>
  );
};


export default OutlineDisplay;